<template>
    <main v-html="$store.getters.getContentData.webpage_content"></main>
</template>
<script>
export default {
    name: "Content",
    beforeRouteEnter(to, from, next) {
        document.title = to.params.route.split("-").join(" ");
        next(async (vm) => {
            await vm.$store.dispatch("fetchKv", {
                content: to.params.route,
                lang: to.params.lang,
            });
            await vm.$store.dispatch("fetchContent", {
                content: to.params.route,
                lang: to.params.lang,
            });
        });
    },
    async beforeRouteUpdate(to, from, next) {
        document.title = to.params.route.split("-").join(" ");
        if (from.params.lang !== to.params.lang) {
            await this.$store.dispatch("fetchMenu", { lang: to.params.lang });
        }
        await this.$store.dispatch("fetchKv", {
            content: to.params.route,
            lang: to.params.lang,
        });
        await this.$store.dispatch("fetchContent", {
            content: to.params.route,
            lang: to.params.lang,
        });
        next();
    },
};
</script>
